// Cache for normalized grade names
// const gradeNameCache = new Map<string, string>(); // Removed

// /**
//  * Normalizes a grade name to a standardized format
//  * e.g., "Kindergarten" -> "K", "1st Grade" -> "1"
//  */
// function normalizeGradeName(name: string): string { // Removed
//   if (gradeNameCache.has(name)) {
//     return gradeNameCache.get(name)!;
//   }
// 
//   let result: string;
//   if (name.toLowerCase().includes('kindergarten') || name === '0') {
//     result = 'K';
//   } else {
//     const numericMatch = name.match(/\d+/);
//     if (numericMatch) {
//       result = numericMatch[0];
//     } else {
//       result = name;
//     }
//   }
// 
//   gradeNameCache.set(name, result);
//   return result;
// }

// Cache for formatted grade displays
// const gradeDisplayCache = new WeakMap<Grade[], string>(); // Removed

/**
 * Returns the grade string or 'N/A' if not provided.
 * @param gradesInput An array of grade strings, a single grade string, null, or undefined.
 * @returns The formatted grade string or 'N/A'.
 */
export function formatGradeDisplay(gradesInput?: string[] | string | null): string {
  if (!gradesInput) return 'N/A';
  
  // Handle array of grades
  if (Array.isArray(gradesInput)) {
    if (gradesInput.length === 0) return 'N/A';
    if (gradesInput.length === 1) return gradesInput[0].trim();
    
    // Sort grades numerically, handling 'K' specially
    const sortedGrades = [...gradesInput].sort((a, b) => {
      if (a === 'K') return -1;
      if (b === 'K') return 1;
      return parseInt(a) - parseInt(b);
    });
    
    return `${sortedGrades[0]}-${sortedGrades[sortedGrades.length - 1]}`;
  }
  
  // Handle single grade string
  return gradesInput.trim();
}

// Formats a grade name to a standard presentation (e.g., "6th Grade")
export function formatGradeName(gradeName: string): string {
  const gradeWordToNumberMap: Record<string, number> = {
    first: 1,
    second: 2,
    third: 3,
    fourth: 4,
    fifth: 5,
    sixth: 6,
    seventh: 7,
    eighth: 8,
    ninth: 9,
    tenth: 10,
    eleventh: 11,
    twelfth: 12,
  };

  function getOrdinalSuffix(n: number): string {
    const j = n % 10,
      k = n % 100;
    if (j === 1 && k !== 11) return 'st';
    if (j === 2 && k !== 12) return 'nd';
    if (j === 3 && k !== 13) return 'rd';
    return 'th';
  }

  // Handle Kindergarten
  if (gradeName.toLowerCase() === 'kindergarten' || gradeName.toLowerCase() === 'k') {
    return 'Kindergarten';
  }

  // Remove "Grade" suffix if present
  const gradeWord = gradeName.toLowerCase().replace(/\s*grade$/, '');

  // Check if it's a word-based grade (e.g., "sixth")
  if (gradeWordToNumberMap[gradeWord]) {
    const gradeNumber = gradeWordToNumberMap[gradeWord];
    return `${gradeNumber}${getOrdinalSuffix(gradeNumber)} Grade`;
  }

  // Check if it's already a number (e.g., "6")
  if (/^\d+$/.test(gradeWord)) {
    const gradeNumber = parseInt(gradeWord, 10);
    return `${gradeNumber}${getOrdinalSuffix(gradeNumber)} Grade`;
  }

  // If no match, return the original name
  return gradeName;
} 